@if (familyMember()) {
  <br />
  <app-info-message
    [label]="'Jeśli osoba jest cudzoziemcem nieposiadającym numeru PESEL konieczne jest podanie numeru innego dokumentu tożsamości.'"
  >
  </app-info-message>
  <br />
}
<form class="grid grid-cols-1 md:grid-cols-3 gap-4" [formGroup]="formGroup()">
  <div class="flex flex-col gap-2">
    <label for="surname" appRequiredLabel="nazwisko">Nazwisko</label>
    <input
      id="surname"
      pInputText
      appControlError
      [formControl]="formGroup().controls.nazwisko"
      [readonly]="readonlyControls().includes('nazwisko')"
    />
  </div>
  <div class="flex flex-col gap-2">
    <label for="firstName" appRequiredLabel="imie">Imię</label>
    <input
      id="firstName"
      pInputText
      appControlError
      [formControl]="formGroup().controls.imie"
      [readonly]="readonlyControls().includes('imie')"
    />
  </div>
  <div class="flex flex-col gap-2">
    <label for="secondName" appRequiredLabel="drugieImie">Drugie imię</label>
    <input
      id="secondName"
      pInputText
      appControlError
      [formControl]="formGroup().controls.drugieImie"
      [readonly]="readonlyControls().includes('drugieImie')"
      [maxlength]="50"
    />
  </div>
  <div class="flex flex-col gap-2">
    <label for="pesel" appRequiredLabel="pesel">PESEL</label>
    <input
      id="pesel"
      pInputText
      appControlError
      [isInvalidCondition]="
        formGroup().hasError('peselOrDocumentRequired') ||
        formGroup().hasError('peselPlecInvalid')
      "
      [maxlength]="11"
      [formControl]="formGroup().controls.pesel"
      [readonly]="readonlyControls().includes('pesel')"
    />
  </div>
  @if (familyMember()) {
    <div class="flex flex-col gap-2">
      <label for="dataUrodzenia">Data urodzenia</label>
      <p-datePicker
        id="dataUrodzenia"
        inputId="dataUrodzenia"
        inputStyleClass="w-full"
        [maxDate]="maxDate"
        dateFormat="dd-mm-yy"
        [formControl]="formGroup().controls.dataUrodzenia"
        [firstDayOfWeek]="1"
      />
    </div>
    <div class="flex flex-col gap-2"></div>
  }
  <div class="flex flex-col gap-2">
    <span id="documentType" appRequiredLabel="rodzajDokumentu"
      >Rodzaj dokumentu</span
    >
    <p-select
      ariaLabelledBy="documentType"
      appControlError
      [isInvalidCondition]="formGroup().hasError('peselOrDocumentRequired')"
      [options]="documentTypeItems"
      [formControl]="formGroup().controls.rodzajDokumentu"
      [readonly]="readonlyControls().includes('rodzajDokumentu')"
      [showClear]="true"
      optionLabel="label"
      optionValue="value"
      dataKey="value"
      placeholder="Wybierz rodzaj dokumentu"
      class="w-full"
      appendTo="body"
    />
  </div>
  <div class="flex flex-col gap-2">
    <label for="documentNumber" appRequiredLabel="nrDokumentu"
      >Numer dokumentu</label
    >
    <input
      id="documentNumber"
      pInputText
      appControlError
      class="uppercase"
      [isInvalidCondition]="formGroup().hasError('peselOrDocumentRequired')"
      [formControl]="formGroup().controls.nrDokumentu"
      [readonly]="readonlyControls().includes('nrDokumentu')"
      [maxlength]="25"
    />
  </div>
  <div class="flex flex-col gap-2">
    <span id="citizenship" appRequiredLabel="obywatelstwo">Obywatelstwo</span>
    <p-select
      ariaLabelledBy="citizenship"
      appControlError
      [options]="obywatelstwa()"
      [formControl]="formGroup().controls.obywatelstwo"
      [readonly]="readonlyControls().includes('obywatelstwo')"
      optionLabel="nazwa"
      placeholder="Wybierz obywatelstwo"
      class="w-full"
      appendTo="body"
      dataKey="kod"
      [filter]="true"
      filterBy="nazwa"
      filterPlaceholder="Wyszukaj obywatelstwo"
    />
  </div>
  <div class="flex flex-col gap-2">
    <span id="gender" appRequiredLabel="plec">Płeć</span>
    <p-select
      ariaLabelledBy="gender"
      appControlError
      [isInvalidCondition]="
        formGroup().hasError('stanCywilnyPlecInvalid') ||
        formGroup().hasError('peselPlecInvalid')
      "
      [options]="genderItems"
      [formControl]="formGroup().controls.plec"
      [readonly]="readonlyControls().includes('plec')"
      optionLabel="label"
      optionValue="value"
      placeholder="Wybierz płeć"
      class="w-full"
      [dataKey]="'value'"
      appendTo="body"
    />
  </div>
  <div class="flex flex-col gap-2">
    <span id="martialStatus" appRequiredLabel="stanCywilny">Stan cywilny</span>
    <p-select
      ariaLabelledBy="martialStatus"
      appControlError
      [isInvalidCondition]="formGroup().hasError('stanCywilnyPlecInvalid')"
      [options]="martialStatusItems"
      [formControl]="formGroup().controls.stanCywilny"
      [readonly]="readonlyControls().includes('stanCywilny')"
      optionLabel="nazwa"
      placeholder="Wybierz stan cywilny"
      class="w-full"
      appendTo="body"
      dataKey="nazwa"
    />
  </div>
</form>

<div class="mt-4">
  <app-error-summary
    [errors]="formGroup().errors | errorMessages"
  ></app-error-summary>
</div>
